import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const allEnumsStore = createSlice({
  name: 'user',
  initialState: {} as Record<string, any>,
  reducers: {
    SetEnums(_state, action: PayloadAction<any>) {
      if (!action?.payload || typeof action.payload !== 'object') {
        return {};
      }
      return { ...action.payload, password: '' };
    },
  },
});

export default allEnumsStore;
export const { SetEnums } = allEnumsStore.actions;
